import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import teamService from "../../Services/TeamService";
import {
  showSuccessToast,
  showErrorToast,
} from '../../Constant/Notification'
import { getIcons } from "../../Constant/Constant";
import Loader from "../../Constant/Loader";
import CustomHeading from "../../common/CustomHeading";

// // Custom styles for Modal
// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     width: "40%",
//     padding: "20px",
//     position: "relative",
//   },
//   overlay: {
//     zIndex: 1000,
//     backgroundColor: "rgba(0, 0, 0, 0.75)",
//   },
// };



// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, 50px)", // Start from below
//     width: "40%",
//     padding: "20px",
//     position: "relative",
//     transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
//     opacity: 0,
//   },
//   overlay: {
//     zIndex: 1000,
//     backgroundColor: "rgba(0, 0, 0, 0.75)",
//     transition: "opacity 0.3s ease-out",
//   },
// };

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    padding: "20px",
    position: "relative",
    transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
  },
  overlay: {
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    transition: "opacity 0.3s ease-out",
  },
};

// Bind modal to your appElement
Modal.setAppElement("#root");
const icons = getIcons();
const SaleTeam = () => {
  const [team, setTeam] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTeams, setFilteredTeams] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [newTeamName, setNewTeamName] = useState("");
  const [updateTeamName, setUpdateTeamName] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null); // For the team to be updated



  useEffect(() => {
    if (isUpdateModalOpen) {
      setTimeout(() => {
        document.querySelector(".ReactModal__Content").style.transform = "translate(-50%, -50%)";
        document.querySelector(".ReactModal__Content").style.opacity = 1;
      }, 10);
    }
  }, [isUpdateModalOpen]);
  const navigate = useNavigate();

  const fetchTeamData = async () => {
    setLoading(true);
    try {
      const response = await teamService.fetchTeams();
      setTeam(response.data);
      setFilteredTeams(response.data);
    } catch (error) {
      showErrorToast(error.response.data)

      console.error("Error fetching Teams", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTeamData();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    const filtered = team.filter((team) =>
      team.name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setFilteredTeams(filtered);
  };

  const handleCreateTeamClick = () => {
    setIsModalOpen(true);
  };

  const handleUpdateTeamClick = (team) => {
    setSelectedTeam(team);
    setUpdateTeamName(team.name);
    setIsUpdateModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setNewTeamName("");
    setErrors({});
  };

  const handleCloseUpdateModal = () => {
    setIsUpdateModalOpen(false);
    setUpdateTeamName("");
    setSelectedTeam(null);
    setErrors({});
  };

  const validateForm = (name) => {
    const newErrors = {};
    if (!name) newErrors.name = "Name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateTeam = async (e) => {
    e.preventDefault();
    if (!validateForm(newTeamName)) {
      return;
    }
    setLoading(true);
    const teamData = { name: newTeamName.trim() };

    try {
      const teamResponse = await teamService.validateTeamName(teamData.name);
      if (teamResponse.data.duplicate) {
        setErrors({ name: "Team Name already exists" });
        showErrorToast("Team Name already exists");
        setLoading(false);
        return;
      } else {
        setErrors({});
      }
      const response = await teamService.createTeam(teamData);
      setTeam([...team, response.data]);
      setFilteredTeams([...team, response.data]);
      await fetchTeamData();
      handleCloseModal();
      showSuccessToast("Team Created Successfully");
    } catch (error) {
      showErrorToast(error.response.data)

      console.error("There was an error creating the team:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateTeam = async (e) => {
    e.preventDefault();
    if (!validateForm(updateTeamName)) {
      return;
    }
    setLoading(true);

    const teamData = { name: updateTeamName.trim() };

    try {

      const teamResponse = await teamService.validateTeamName(teamData.name);
      if (teamResponse.data.duplicate && teamData.name !== selectedTeam.name) {
        setErrors({ name: "Team Name already exists" });
        showErrorToast("Team Name already exists");
        setLoading(false);

        return;
      } else {
        setErrors({});
      }

      await teamService.updateTeam(selectedTeam.teamId, teamData);
      await fetchTeamData();

      handleCloseUpdateModal();
      showSuccessToast("Team Updated Successfully");
    } catch (error) {
      showErrorToast(error.response.data)

      console.error("There was an error updating the team:", error);
    } finally {
      setLoading(false); // Enable button after submit
    }
  };

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const handleTeamInfo = (team) => {
    if(userRole === "Admin"){
      navigate(`/admin/sales-teaminfo/${team.teamId}`, { state: { team } });

    }else if (userRole === "CMO"){
      navigate(`/cmo/sales-teaminfo/${team.teamId}`, { state: { team } });

    }
  };

  return (
    <div className="bg-appGrayBackground  pb-10 pt-20">
      {loading ? <Loader/> :""}
      <AdminAppBar />
      <ToastContainer />

      <div className="mt-10 px-20 xl:px-6 relative flex justify-between gap-5">
      <CustomHeading title={`Sales Team (${filteredTeams.length})`} isIcon={true}/> 


        <div className="relative flex w-[700px] 4xl:w-[1600px] 2xl:w-[900px] 3xl:w-[1300px] items-center ">
          <img src={icons.searchIcon} alt="" className="absolute left-4 w-5 h-5" />
          <input
            type="text"
            placeholder="Search Team"
            value={searchTerm}
            onChange={handleSearchChange}
            className="setup-search pl-10 pr-4  h-10 border-stone-400 shadow appearance-none border rounded text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>

        <div>
          <button
            onClick={handleCreateTeamClick}
            className="border-2 whitespace-nowrap border-customGreen rounded-sm p-1 px-5 w-fit text-lg text-customGreen h-10 text-center"
          >
            +Create a New Team
          </button>
        </div>
      </div>

      <div className="list-container bg-white mt-10 rounded-md shadow-md w-12/12 pt-6 mx-20 xl:mx-6 pb-6">
        <div className="list-scroller overflow-y-auto max-h-[500px]  3xl:max-h-[850px] 4xl:max-h-[750px] custom-scrollbar">
          {/* {loading ? (
            <div className="flex justify-center items-center h-full">
              <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-customGreen"></div>
            </div>
          ) : ( */}
            <table className="w-full table-fixed">
              <thead className="bg-white sticky top-0">
                <tr className="border-b ">
                  <th className="text-customGreen text-2xl 4xl:text-3xl">
                    Teams
                  </th>
                  <th className="text-customGreen text-2xl 4xl:text-3xl">
                    Team Members
                  </th>
                  <th className="text-customGreen text-2xl 4xl:text-3xl">
                    BOD
                  </th>
                  <th className="text-customGreen text-2xl 4xl:text-3xl">MD</th>
                  <th className="w-20"></th>
                </tr>
              </thead>
              <tbody>
                {filteredTeams.map((team) => (
                  <tr
                    key={team.id}
                    className="text-center px-20 w-full  font-medium border-b xl:text-sm 3xl:text-lg 4xl:text-2xl"
                  >
                    {/* <td className="pl-16 py-4">
                          <div className="flex items-center">
                            <span className="text-4xl text-customGreen mr-2">&bull;</span>
                            <div className="flex flex-col text-left">
                              <div className="ml-4">{team.name}</div>

                            </div>
                          </div>
                        </td> */}

                    <td
                      className="text-center text-[#2280FF] hover:text-[#223fff] flex ml-20 xl:ml-14 custom-xl:ml-16 4xl:ml-36 py-5 cursor-pointer"
                      onClick={() => handleTeamInfo(team)}
                    >
                      <div className="flex items-center justify-center">
                        <span
                          className="text-4xl text-customGreen"
                          style={{ minWidth: "1em" }}
                        >
                          &bull;
                        </span>
                        <span 
                        title={team.name}
                        className="text-start max-w-[200px] cursor-pointer truncate  ">
                          {team.name}
                        </span>
                      </div>
                    </td>

                    <td>{team?.totalMembers}</td>
                    {/* <td>
                      {team?.BOD.map((val, index) => (
                        <div>
                          {" "}
                          {val.name}
                          {team.BOD.length == index + 1 ? "" : ","}
                        </div>
                      ))}{" "}
                      {team?.BOD.length == 0 ? "N/A" : ""}
                    </td> */}


<td>
  {team?.BOD && team.BOD.length > 0 ? (
    team.BOD.map((val, index) => (
      <div key={index}>
        {val.name}
        {team.BOD.length === index + 1 ? "" : ","}
      </div>
    ))
  ) : (
    "N/A"
  )}
</td>

                    <td>{team?.MD?.name ? team?.MD?.name : "N/A"}</td>
                    <td
                      className="text-sky-400 cursor-pointer"
                      onClick={() => handleUpdateTeamClick(team)}
                    >
                      Edit
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          {/* )} */}
        </div>
      </div>

      {/* Create Team Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Create Team"
        style={customStyles}
      >
        <button
          onClick={handleCloseModal}
          className="absolute top-2 right-2 text-2xl text-gray-700"
        >
          &times;
        </button>
        <h2 className="text-3xl font-semibold mb-4">Create New Team</h2>
        <form onSubmit={handleCreateTeam}>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-xl font-bold mb-2"
              htmlFor="name"
            >
              Team Name
            </label>
            <input
              type="text"
              id="name"
              value={newTeamName}
              placeholder="Enter a Team Name"
              onChange={(e) =>
                setNewTeamName(
                  e.target.value.charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                )
              }
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />

          </div>
          <div className="flex justify-end">
            {/* <button
              type="submit"
              className='bg-customGreen hover:bg-customGreen-dark text-lg text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Create Team
            </button> */}
            <button
              onClick={handleCreateTeam}
              className="bg-customGreen text-white md:w-28 md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl lg:text-2xl font-medium"
              disabled={loading} // Disable button while loading
            >
              {/* {loading ? (
                <div className="flex justify-center items-center h-full">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-white"></div>
                </div>
              ) : (
                "Create Team"
              )} */}
              Create Team
            </button>
          </div>
        </form>
      </Modal>

      {/* Update Team Modal */}
      <Modal
        isOpen={isUpdateModalOpen}
        onRequestClose={handleCloseUpdateModal}
        contentLabel="Update Team"
        style={customStyles}
        closeTimeoutMS={300}
      >
        <button
          onClick={handleCloseUpdateModal}
          className="absolute top-2 right-2 text-2xl text-gray-700"
        >
          &times;
        </button>
        <h2 className="text-3xl font-semibold mb-4">Update Team</h2>
        <form onSubmit={handleUpdateTeam}>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-xl font-bold mb-2"
              htmlFor="update-name"
            >
              Team Name
            </label>
            <input
              type="text"
              id="update-name"
              value={updateTeamName}
              placeholder="Enter a Team Name"
              onChange={(e) =>
                setUpdateTeamName(
                  e.target.value.charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                )
              }
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div className="flex justify-end">
            {/* <button
              type="submit"
              className='bg-customGreen hover:bg-customGreen-dark text-lg text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            >
              Update Team
            </button> */}
            <button
              onClick={handleUpdateTeam}
              className="bg-customGreen text-white md:w-28 md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl lg:text-2xl font-medium"
              disabled={loading} // Disable button while loading
            >
              {/* {loading ? (
                <div className="flex justify-center items-center h-full">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-white"></div>
                </div>
              ) : (
                "Update Team"
              )} */}
              Update Team
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default SaleTeam;
